import { make } from 'redux-chill';

import type { SenderInfo } from '../types';

const setDeliverySenderInfo = make('[delivery] set sender info')
  .stage((info: SenderInfo) => ({ info }))
  .stage('reset');

export { setDeliverySenderInfo };
